'use strict';

var _setup = require('./setup.js');

//list of all sites for the language select dropdown
// - name - used as text in dropdown
// - lang - used as text in dropdown
// - abbr - used for unique classname (flags are bg's in css)
// - host - the site's hostname to match & determine current site
// - devUrl - the shopify url for the store

// nexgrill-canada: ca-en.nexgrill.com
// nexgrill-french-canada: ca-fr.nexgrill.com
// nexgrill-uk: nexgrill.co.uk
// nexgrill-denmark-english: dk-en.nexgrill.dk
// nexgrill-denmark-danish: nexgrill.dk
// nexgrill-swedish: nexgrill.se
// nexgrill-swedish-english:  se-en.nexgrill.se
// nexgrill-french-english: fr-en.nexgrill.fr
// nexgrill-french-french: www.nexgrill.fr


//all international site info -----//
var nxmlSites = [{
  name: 'USA',
  abbr: 'US',
  flag: 'us',
  lang: 'English',
  label: 'US (English)',
  host: 'nexgrill.com',
  code: 'en-us',
  devUrl: 'nexgrill-dev.myshopify.com',
  active: true
}, {
  name: 'USA',
  abbr: 'US',
  flag: 'us',
  lang: 'French',
  label: 'FR (French)',
  host: 'us-fr.nexgrill.com',
  code: 'fr-us',
  devUrl: 'nexgrill-french-usa.myshopify.com',
  active: true
}, {
  name: 'Canada',
  abbr: 'CA',
  flag: 'ca',
  lang: 'English',
  label: 'CA (English)',
  host: 'nexgrill.ca',
  code: 'en-ca',
  devUrl: 'nexgrill-canada.myshopify.com',
  active: true
}, {
  name: 'Canada',
  abbr: 'CA',
  flag: 'ca',
  lang: 'French',
  label: 'CA (French)',
  host: 'ca-fr.nexgrill.ca',
  code: 'fr-ca',
  devUrl: 'nexgrill-french-canada.myshopify.com',
  active: true
}, {
  name: 'Denmark',
  abbr: 'DK',
  flag: 'dk',
  lang: 'English',
  label: 'DK (English)',
  host: 'dk-en.nexgrill.dk',
  code: 'en-dk',
  devUrl: 'nexgrill-denmark-english.myshopify.com',
  active: true
}, {
  name: 'Denmark',
  abbr: 'DK',
  flag: 'dk',
  lang: 'Danish',
  label: 'DK (Danish)',
  host: 'nexgrill.dk',
  code: 'da-dk',
  devUrl: 'nexgrill-denmark-danish.myshopify.com',
  active: true
}, {
  name: 'Sweden',
  abbr: 'SE',
  flag: 'se',
  lang: 'Swedish',
  label: 'SE (Swedish)',
  host: 'nexgrill.se',
  code: 'sv-se',
  devUrl: 'nexgrill-swedish.myshopify.com',
  active: true
}, {
  name: 'Sweden',
  abbr: 'SE',
  flag: 'se',
  lang: 'English',
  label: 'SE (English)',
  host: 'se-en.nexgrill.se',
  code: 'en-se',
  devUrl: 'nexgrill-swedish-english.myshopify.com',
  active: true
}, {
  name: 'France',
  abbr: 'FR',
  flag: 'fr',
  lang: 'English',
  label: 'FR (English)',
  host: 'fr-en.nexgrill.fr',
  code: 'en-fr',
  devUrl: 'nexgrill-french-english.myshopify.com',
  active: true
}, {
  name: 'France',
  abbr: 'FR',
  flag: 'fr',
  lang: 'French',
  label: 'FR (French)',
  host: 'nexgrill.fr',
  code: 'fr-fr',
  devUrl: 'nexgrill-french-french.myshopify.com',
  active: true
}, {
  name: 'United Kingdom',
  abbr: 'UK',
  flag: 'uk',
  lang: 'English',
  label: 'UK (English)',
  host: 'nexgrill.co.uk',
  code: 'en-gb',
  devUrl: 'nexgrill-uk.myshopify.com',
  active: true
}, {
  name: 'Australia',
  abbr: 'AU',
  flag: 'au',
  lang: 'English',
  label: 'Australia (English)',
  host: 'nexgrillbbq.com.au',
  code: 'en-au',
  devUrl: 'nexgrill-au.myshopify.com',
  active: true
}, {
  name: 'Taiwan',
  abbr: 'TW',
  flag: 'tw',
  lang: 'Chinese',
  label: 'Taiwan (Chinese)',
  host: 'nexgrill.com.tw',
  code: 'cn-tw',
  devUrl: 'nexgrill-tw.myshopify.com',
  active: true
}, {
  name: 'Germany',
  abbr: 'GE',
  flag: 'ge',
  lang: 'German',
  label: 'Germany (German)',
  host: 'nexgrill.de',
  code: 'ge-ge',
  devUrl: 'nexgrill-germany.myshopify.com',
  active: true /* , {
                name: 'Germany',
                abbr: 'GE',
                flag: 'ge',
                lang: 'English',
                label: 'Germany (English)',
                host: 'de-en.nexgrill.com',
                code: 'en-ge',
                devUrl: 'nexgrill-germany-english.myshopify.com',
                active: false
               } */ }];
//- end site info


//sort lang drop alphabetically
nxmlSites.sort(function (a, b) {
  var name_a = a.name.toUpperCase();
  var name_b = b.name.toUpperCase();
  if (name_a < name_b) {
    return -1;
  } else if (name_a > name_b) {
    return 1;
  } else {
    var lang_a = a.lang.toUpperCase();
    var lang_b = b.lang.toUpperCase();
    return lang_a < lang_b ? -1 : 1;
  }
});

//might need something like this also, hope not
// const nxmlTranslations = {
//   French: { //match nxmlSites obj keys },
//   Danish: { //etc.. }
// };

//templating
var getListItems = function getListItems(activeIndex) {
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  nxmlSites.forEach(function (site, i) {
    if (!site.active) return;
    var liClass = activeIndex === i ? 'is-active' : '';
    var hrefLang = site.host === 'nexgrill.com' ? 'x-default' : site.code;
    list += '<li class="' + liClass + '">\n              <a href="http://' + site.host + '" rel="alternate" hreflang="' + hrefLang + '">\n                <span class="nx-langdrop--flag flag--' + site.flag + '"><span></span></span>\n                <span class="nx-langdrop--name"><span>' + site.name + '</span> - ' + site.lang + '</span>\n              </a>\n            </li>';
  });
  return list;
},
    dropTemplate = function dropTemplate(extraclasses) {
  var defaultSiteIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var iconDir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'down';
  return '<div class="nx-langdrop ' + extraclasses + '">\n    <button class="nx-langdrop--btn">\n      <span class="nx-langdrop--btnitems">\n        <span class="nx-langdrop--flag flag--' + nxmlSites[defaultSiteIndex].flag + '"><span></span></span>\n        <span class="nx-langdrop--text">\n          <span class="nx-langdrop--current">' + nxmlSites[defaultSiteIndex].abbr + '</span>\n          <i class="icon-' + iconDir + '-dir" aria-hidden="true"></i>\n        </span>\n      </span>\n    </button>\n    <div class="nx-langdrop--list">\n      <div class="nx-langdrop--liner">\n        <ul>' + getListItems(defaultSiteIndex) + '</ul>\n      </div>\n    </div>\n  </div>';
};

//button dropdown (toggle css class)
var bindButtonHandler = function bindButtonHandler(i, item) {
  var $this = $(item),
      $parent = $this.parent('.nx-langdrop'),
      isHeader = $parent.hasClass('nx-header--langdrop');
  $this.on('click', function (e) {
    e.preventDefault();
    if ($parent.hasClass('is-open')) {
      $parent.removeClass('is-open');
      if (isHeader) {
        _setup._s.langDropShowing.header = false;
      } else {
        _setup._s.langDropShowing.footer = false;
      }
    } else {
      $parent.addClass('is-open');
    }
    e.stopPropagation();
  });
};

// Where are we? --------------------------------
// need to test against host name on real domains
var getCurrentLangIndex = function getCurrentLangIndex() {
  var host = window.location.hostname;
  if (host === 'localhost' || host.indexOf('shopifypreview') > -1) return 0;
  for (var i = 0; i < nxmlSites.length; i++) {
    if (nxmlSites[i].host === host || nxmlSites[i].devUrl === host) {
      return i;
    }
  }
};

//close all open dropdowns on outside click
var clearOnClickout = function clearOnClickout() {
  var $opens = $('.nx-langdrop.is-open');
  if ($opens.length) {
    $opens.removeClass('is-open');
    _setup._s.langDropShowing.header = false;
    _setup._s.langDropShowing.footer = false;
  }
};

var langInit = function langInit() {
  var defaultIndex = getCurrentLangIndex();

  //add dropdowns to header/footer
  $('.nx-header--auxlinks').prepend(dropTemplate('nx-header--langdrop', defaultIndex, 'down'));
  $('.nx-footer--copyright').after(dropTemplate('nx-footer--langdrop', defaultIndex, 'up'));

  //btn click handlers
  $('.nx-langdrop--btn').each(bindButtonHandler);
  //clickout behavior
  $(document).on('click', clearOnClickout);
};

langInit();


//////////////////
// WEBPACK FOOTER
// ./_js/lang-menu-drop.js
// module id = 11
// module chunks = 0